import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_BOW_URL } from "./../config";

export const getVaccine = (type_id) => {
  return axios.get(`${API_BOW_URL}/api/dropdown/?type=product&product_type=vaccine&pet_type=${type_id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getParasite = (type_id) => {
  return axios.get(`${API_BOW_URL}/api/dropdown/?type=product&product_type=parasite&pet_type=${type_id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getPetType = () => {
  return axios.get(`${API_BOW_URL}/api/dropdown/?type=pettype`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getPetBreed = () => {
  return axios.get(`${API_BOW_URL}/api/dropdown/?type=petbreed`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};